// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__jRpaf","log":"ModalInventoryLogs_log__tBGwc","date":"ModalInventoryLogs_date__PdXq8","userName":"ModalInventoryLogs_userName__13-Fl"};